import { useParams } from 'react-router-dom';
import { buildCouncilPath, resolveMunicipalityId } from '../utils/councilParams';

export function useMunicipalityId(): string {
    const { municipalitaId } = useParams();
    return resolveMunicipalityId(municipalitaId);
}

export function useCouncilPath() {
    const { bodyType, zastupitelstvoId } = useParams();
    const municipalitaId = useMunicipalityId();
    return (...segments: Array<string | number>) =>
        buildCouncilPath(municipalitaId, bodyType, zastupitelstvoId, ...segments);
}
